import { create } from 'zustand';
import request from '@/utils/request';

interface AdminUser {
  id: number;
  username: string;
}

interface AuthState {
  token: string | null;
  admin: AdminUser | null;
  isAuthenticated: boolean;
  loading: boolean;
  login: (
    username: string,
    password: string,
    captchaId: string,
    captchaAnswer: string,
  ) => Promise<void>;
  logout: () => void;
  checkSession: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  token: localStorage.getItem('admin_token'),
  admin: (() => {
    try {
      const stored = localStorage.getItem('admin_user');
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  })(),
  isAuthenticated: !!localStorage.getItem('admin_token'),
  loading: false,

  login: async (
    username: string,
    password: string,
    captchaId: string,
    captchaAnswer: string,
  ) => {
    const { data } = await request.post('/admin/login', {
      username,
      password,
      captchaId,
      captchaAnswer,
    });
    const { token, admin } = data;
    localStorage.setItem('admin_token', token);
    localStorage.setItem('admin_user', JSON.stringify(admin));
    set({ token, admin, isAuthenticated: true });
  },

  logout: () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    set({ token: null, admin: null, isAuthenticated: false });
  },

  checkSession: async () => {
    const token = localStorage.getItem('admin_token');
    if (!token) {
      set({ token: null, admin: null, isAuthenticated: false });
      return;
    }
    try {
      set({ loading: true });
      const { data } = await request.get('/admin/session');
      const admin = data.admin ?? data;
      localStorage.setItem('admin_user', JSON.stringify(admin));
      set({ token, admin, isAuthenticated: true, loading: false });
    } catch {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      set({ token: null, admin: null, isAuthenticated: false, loading: false });
    }
  },
}));
